// removed by extract-text-webpack-plugin
module.exports = {"message":"_2n6RL","slideInRight":"_1LCFc","isMultiMessage":"_2ZPBI","hasAside":"_3hess","arrowBounce":"TMr8y","isCurator":"_2JTRF","slideInLeft":"RZ2wJ","messageBody":"_3_QOb","isQuestion":"_2LWob","name":"_2a-cY","userMS":"_1F888","userSS":"_1xSco","userNZ":"_3zzR3","userPC":"_XR2w","userLX":"_2jQkv","text":"_1uhWv","link":"_2_gju","hasModal":"El6GP","image":"_2Cmej","caption":"oX9jM","video":"_2n-iG"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/styles.css
 ** module id = 341
 ** module chunks = 0
 **/